import { useQuery } from '@tanstack/react-query';
import { queries } from '../../../../../../shared/queries';
import { handleError } from '../../../../../ui/err/handleError';
import { AxiosCommonError } from '../../../../../../shared/types';
import { AxiosError } from 'axios';

export default function useGetUsersByCompany(params: { companyId: number; category: string; keyword: string; service: string }) {
  return useQuery({
    ...queries.user.list(params),
    select: (response) => response.data,
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
  });
}
